import React, { Component, useMemo, useRef, useState } from 'react'
import { MapContainer, Marker, TileLayer, useMapEvents, Polyline } from 'react-leaflet'
import MarkerClusterGroup from "react-leaflet-cluster"
import mapMarker from '../assets/svg/map-marker.svg'
import ReactDOMServer from 'react-dom/server'
import helper from '../utils/helper'
import { divIcon, marker } from 'leaflet'
import '../assets/style.css'
import 'leaflet/dist/leaflet.css'
import { last } from 'underscore'

class Mapa extends Component {
    mapRef = React.createRef()
    mapId = helper.randomKey(12)

    static defaultProps = {
        allowDragging: true,
        allowZoom: true,
        layerControl: false,
    }

    state = (() => {
        let savedLayerType = 1;
        let savedLayerUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        let savedClusterGroup = false;

        try {
            const saved = localStorage.getItem("mapLayerSettings");
            if (saved) {
                const settings = JSON.parse(saved);

                const storageKey = this.props.storageKey ?? "mapaDefault";
                const layerType = settings?.[storageKey]?.mapaLayer;
                if (layerType) {
                    savedLayerType = Number(layerType);
                    savedLayerUrl = savedLayerType === 2
                        ? "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                        : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
                }

                const agrupamento = settings?.[storageKey]?.agrupamento;
                if (agrupamento !== undefined) {
                    savedClusterGroup = agrupamento === 1;
                }
            }
        } catch (e) {
            console.error("Erro ao carregar layer do localStorage", e);
        }

        return {
            position: this.props.initialPosition ?? [-17.408282, -53.117169],
            zoom: 4,
            layerUrl: savedLayerUrl,
            layerType: savedLayerType,
            clusterGroup: savedClusterGroup,
        };
    })();

    componentDidMount = () => {
        setTimeout(() => {
            this.props.onLoad && this.props.onLoad(this.mapRef)

            if (this.props.layerControl) {
                const div = document.createElement('div')
                div.setAttribute('class', 'map-layer-ctrl')

                const isMapaSelected = this.state.layerType === 1 ? 'selected' : '';
                const isSateliteSelected = this.state.layerType === 2 ? 'selected' : '';

                div.innerHTML = ReactDOMServer.renderToString(
                    <>
                        <button data-map-layer="1" className={isMapaSelected}>Mapa</button>
                        <button data-map-layer="2" className={isSateliteSelected}>Satélite</button>
                    </>
                )

                const map = document.querySelector(`div[data-map-id="${this.mapId}"] .leaflet-control-container`)
                map.appendChild(div)

                document.querySelectorAll(".leaflet-control-container button").forEach((btn) => {
                    btn?.addEventListener('click', (e) => this.handleLayer(e.target.dataset.mapLayer))
                })
            }

            if (this.props.clusterGroup) {
                const div = document.createElement('div')
                div.setAttribute('class', 'map-layer-ctrl')
                const desagruparSelected = !this.state.clusterGroup ? 'selected' : '';
                const agruparSelected = this.state.clusterGroup ? 'selected' : '';

                div.innerHTML = ReactDOMServer.renderToString(
                    <>
                        <button id='desagrupar' className={desagruparSelected}>Desagrupar</button>
                        <button id='agrupar' className={agruparSelected}>Agrupar</button>
                    </>
                )

                div.style = 'left: 12px; width: fit-content; top: calc(100% - 40px)'

                document.querySelector('.leaflet-control-container').appendChild(div)

                document.getElementById('desagrupar')?.addEventListener('click', () => this.changeClusterMap(false))
                document.getElementById('agrupar')?.addEventListener('click', () => this.changeClusterMap(true))
            }
        }, 0)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.layerType !== this.state.layerType) {
            this.saveMapSettings({ mapaLayer: this.state.layerType });
        }
    }

    flyToMarker = (latitude, longitude, zoom = 17) => {
        const map = this.mapRef?.current;
        if (map) {
            map.setView([latitude, longitude], zoom);
        }
    }

    getStorageKey = () => {
        return this.props.storageKey ?? "mapaDefault";
    }

    saveMapSettings = (partial) => {
        try {
            const storageKey = this.props.storageKey ?? "mapaDefault";

            const saved = localStorage.getItem("mapLayerSettings");
            const current = saved ? JSON.parse(saved) : {};

            const updatedSettings = {
                ...current,
                [storageKey]: {
                    ...(current[storageKey] ?? {}),
                    ...partial,
                },
            };

            localStorage.setItem("mapLayerSettings", JSON.stringify(updatedSettings));
        } catch (e) {
            console.error("Erro ao salvar configurações do mapa", e);
        }
    }

    changeClusterMap = (clusterGroup) => {
        let desagrupar = document.getElementById('desagrupar')
        let agrupar = document.getElementById('agrupar')

        if (clusterGroup) {
            desagrupar.classList.remove('selected')
            agrupar.classList.add('selected')
        } else {
            desagrupar.classList.add('selected')
            agrupar.classList.remove('selected')
        }

        this.saveMapSettings({ agrupamento: clusterGroup ? 1 : 0 });
        this.setState({ clusterGroup });
    }

    handleLayer = (type) => {
        let layerUrl
        type = Number(type)

        if (type == 1) {
            layerUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        } else if (type == 2) {
            layerUrl = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        }

        const button = document.querySelector(`.leaflet-control-container button[data-map-layer="${type}"]`)
        const buttonRemove = document.querySelector(`.leaflet-control-container button[data-map-layer="${type == 1 ? 2 : 1}"]`)

        button.classList.add("selected")
        buttonRemove.classList.remove("selected")

        this.setState({ layerUrl, layerType: type })
    }

    render() {
        let { position, layerUrl, clusterGroup } = this.state

        return (
            <div data-map-id={this.mapId}>
                <MapContainer
                    id="map"
                    center={position}
                    zoom={this.props.zoom ? this.props.zoom : 4}
                    zoomControl={this.props.allowZoom}
                    dragging={this.props.allowDragging}
                    scrollWheelZoom={this.props.allowDragging}
                    ref={this.mapRef}
                    style={this.props.style ?? {}}>
                    <TileLayer
                        url={layerUrl}
                        ext="png"
                        attribution='&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    />

                    {!clusterGroup ?
                        this.props.markers?.map((marker, index) => {
                            if (this.props.draggable) {
                                return (
                                    <DraggableMarker
                                        position={[marker.latitude, marker.longitude]}
                                        onSelect={(pos) => this.props?.onClick(pos)}
                                        markerElement={marker.iconElement}
                                    />
                                )
                            }

                            if (marker?.defaultMarker) {
                                return (
                                    <DefaultMarker
                                        key={index}
                                        position={[marker.latitude, marker.longitude]}
                                    />
                                )
                            }

                            return (
                                <Marker
                                    key={index}
                                    position={[marker.latitude, marker.longitude]}
                                    icon={marker?.iconElement}
                                    eventHandlers={{
                                        click: marker?.click
                                    }}>
                                </Marker>
                            )
                        })
                        :
                        <MarkerClusterGroup showCoverageOnHover={false} maxClusterRadius={30}>
                            {this.props.markers?.map((marker, index) => {
                                if (this.props.draggable) {
                                    return (
                                        <DraggableMarker
                                            position={[marker.latitude, marker.longitude]}
                                            onSelect={(pos) => this.props?.onClick(pos)}
                                            markerElement={marker.iconElement}
                                        />
                                    )
                                }

                                if (marker?.defaultMarker) {
                                    return (
                                        <DefaultMarker
                                            key={index}
                                            position={[marker.latitude, marker.longitude]}
                                        />
                                    )
                                }

                                return (
                                    <Marker
                                        key={index}
                                        position={[marker.latitude, marker.longitude]}
                                        icon={marker?.iconElement}
                                        eventHandlers={{
                                            click: marker?.click
                                        }}>
                                    </Marker>
                                )
                            })}
                        </MarkerClusterGroup>
                    }

                    {
                        this.props.trackerPositions && <Polyline pathOptions={{ color: 'black', weight: 5, opacity: 0.7}} positions={this.props.trackerPositions} />
                    }
                </MapContainer>
            </div>
        )
    }
}

export function DraggableMarker({ position, onSelect, markerElement }) {
    const [pos, setPos] = useState(position)
    const markerRef = useRef(null)

    useMapEvents({
        click(e) {
            setPos([e.latlng.lat, e.latlng.lng])
            onSelect([e.latlng.lat, e.latlng.lng])
        }
    })

    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    let latLng = marker.getLatLng()
                    setPos(marker.getLatLng())
                    onSelect([latLng.lat, latLng.lng])
                }
            },
        }),
        [],
    )

    return (
        <Marker
            ref={markerRef}
            draggable={true}
            eventHandlers={eventHandlers}
            position={pos}
            icon={markerElement}>
        </Marker>
    )
}

export function DefaultMarker({ position }) {
    const markerRef = useRef(null)

    return (
        <Marker
            ref={markerRef}
            position={position}
            icon={divIcon({
                className: 'default-div-icon',
                iconSize: [32, 32],
                iconAnchor: [22, 40],
                html: ReactDOMServer.renderToString(
                    <div className="default-marker-container">
                        <img src={mapMarker} width={42} height={42} />
                        <div className="default-marker-gradient"></div>
                    </div>
                )
            })}>
        </Marker>
    )
}

export default Mapa